

export const ActionButton: React.FC<{ loading: boolean, textOnsubmit: string, btnText: string, click?: (e: any) => void, disabled?: boolean }> = ({ loading, btnText, textOnsubmit, click, disabled = false }) => {
    const isDisabled = loading || disabled;

    return (
        <button
            type="submit"
            disabled={isDisabled}
            onClick={click}
            className={`
            flex min-h-[48px] w-full items-center justify-center rounded-lg px-4 py-3 text-sm font-black text-white shadow-[0_14px_28px_rgba(51,83,3,0.24)] transition-colors
            ${ isDisabled ? "cursor-not-allowed bg-slate-300 shadow-none" : "cursor-pointer bg-[#3f6f00] hover:bg-[#315800] active:bg-[#294900]"
                }`}
        >
            {loading ? (
                <>
                    <svg
                        className="animate-spin h-5 w-5 mr-2 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                    </svg>
                    {textOnsubmit}
                </>
            ) : (
                btnText
            )}
        </button>
    )
}
